<!--
 * @Author: zhubincong
 * @Date: 2020-3-9 19:41:31
 * @Desc: 中心地图
 -->
<template>
  <div class="center-map">
    <span class="center-map-title">
      {{ title }}
    </span>
    <div ref="chart" class="chart"></div>
    <ul v-show="showRangeRateLegend" class="range-rate-wrap">
      <li v-for="item in $options.constants.RANK_RATES" :key="item.label" class="flex items-center">
        <span
          :style="{ backgroundColor: item.color, boxShadow: `0 0 6px 0 ${item.color}` }"
          class="center-map-g2-legend-marker"
        ></span>
        <span class="rate-range">{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import G2 from '@antv/g2'
import DataSet from '@antv/data-set'
import { isIe } from '@hui-pro/utils'
import { RANK_RATES } from '../constant'

export default {
  name: 'CenterMap',
  inject: ['$riskMonitor'],
  props: {
    title: {
      type: String,
      default: ''
    },
    geoData: {
      type: Object,
      default: null
    },

    // 尺寸类型
    sizeMode: {
      type: String,
      default: ''
    }
  },
  constants: {
    RANK_RATES // 区域等级率配置
  },
  data() {
    return {
      // 图表尺寸
      chartSize: {
        lg: {
          height: 500,
          width: 936
        },
        md: {
          height: 295,
          width: 782
        },
        sm: {
          height: 295,
          width: 624
        }
      },
      chart: null,
      showRangeRateLegend: false // 显示区域等级率图例
    }
  },
  watch: {
    geoData() {
      this.render()
    },
    sizeMode(data) {
      this.changeChartSize()
    }
  },
  methods: {
    render() {
      const { height, width } = this.chartSize[this.sizeMode]
      const chart = new G2.Chart({
        container: this.$refs.chart,
        forceFit: true,
        height,
        width,
        padding: [20, 80, 30, 240]
      })
      this.chart = chart
      chart.scale({
        longitude: { sync: true, nice: false },
        latitude: { sync: true, nice: false }
      })
      chart.axis(false)
      chart.tooltip({
        showTitle: false,
        'g2-tooltip': {
          background: 'rgba(9, 52, 65, .85)',
          'box-shadow': '0 4px 8px rgba(0, 0, 0, 0.5)'
        },
        'g2-tooltip-list-item': {
          color: '#c4f1f9'
        }
      })
      const dataView = new DataSet().createView('back').source(this.geoData, {
        type: 'GeoJSON'
      })
      const mapView = chart.view()
      mapView.source(dataView)
      const style = {
        stroke: '#fff',
        lineWidth: 1,
        shadowColor: '#145166',
        shadowOffsetY: 8
      }
      // IE不支持渐变效果
      style.fill = isIe() ? '#145188' : 'r(0.5,0.5,0.1) 0:#145188 1:#0008'
      mapView
        .polygon()
        .position('longitude*latitude')
        .tooltip('name', value => ({ name: '区域', value }))
        .style(style)
        .opacity(0.5)
      chart.render()
      // 供上层调用
      this.$emit('mounted', chart, chart.view(), dataView)
    },

    /**
     * @author xuchen
     * @date 2020-04-26 19:46:58
     * @desc 修改环形图大小
     */
    changeChartSize() {
      const { width, height } = this.chartSize[this.sizeMode]
      this.chart && this.chart.changeSize(width, height)
    }
  }
}
</script>
<style lang="scss" scoped>
.center-map {
  position: relative;
  background-image: url('~@/assets/images/RiskMonitoring/centermap-bg.png');
  background-size: 100% 100%;
}
.center-map-title {
  position: relative;
  top: 20px;
  left: 70px;
  display: inline-block;
  color: #ffffff;
  opacity: 0.9;
  background: url('~@/assets/images/RiskMonitoring/panel-title-active.png') no-repeat;
  background-size: 100% 100%;
}
.range-rate-wrap {
  position: absolute;
  left: 100px;
  bottom: 50px;
  z-index: 9999;
  .rate-range {
    color: rgb(140, 140, 140);
    font-size: 16px;
  }
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .center-map {
    width: 936px;
    height: 576px;
  }
  .center-map-title {
    height: 54px;
    line-height: 40px;
    padding: 0 50px 15px 10px;
    font-size: 18px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .center-map {
    width: 782px;
    height: 466px;
  }
  .chart {
    padding-top: 50px;
  }
  .center-map-title {
    height: 46px;
    line-height: 36px;
    padding: 0 40px 10px 10px;
    font-size: 14px;
  }
}

@media screen and (max-width: 1599px) {
  .center-map {
    width: 624px;
    height: 384px;
  }
  .center-map-title {
    height: 34px;
    line-height: 25px;
    padding: 0 28px 6px 10px;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.center-map-g2-legend-marker {
  border-radius: 0 !important;
  width: 9px !important;
  height: 3px !important;
  display: inline-block;
  margin-right: 7px !important;
  vertical-align: middle;
}
</style>
